import { HTMLProps, forwardRef } from 'react'

import { cn } from '../utils.js'

interface Props extends HTMLProps<HTMLDivElement> {
  withShadow?: boolean
  withBorder?: boolean
}

export const Surface = forwardRef<HTMLDivElement, Props>(
  (
    { children, className, withShadow = true, withBorder = true, ...props },
    ref,
  ) => {
    const surfaceClass = cn(
      className,
      'text-content bg-surface rounded-lg',
      withShadow ? 'shadow-sm' : '',
      withBorder ? 'border border-background-subdued' : '',
    )

    return (
      <div className={surfaceClass} {...props} ref={ref}>
        {children}
      </div>
    )
  },
)

Surface.displayName = 'Surface'
